
export const ValidUtil = function () {
  /*
   * 用途：检查输入手机号码是否正确 输入： s：字符串 返回： 如果通过验证返回true,否则返回false
   */
  this.isMobile = function (s) {
    // console.info(s);
    // var myreg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
    var myreg = /^(0|86|17951)?(1[3-9][0-9])[0-9]{8}$/
    if (s == '') {
      return false
    } else if (s.length != 11) {
      return false
    } else if (!myreg.test(s)) {
      return false
    }
    return true
  }
  this.isEmail = function (mail) {
    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
    if (filter.test(mail)) {
      return true
    } else {
      return false
    }
  }

  this.isNotEmpty = function (res) {
    if (res !== undefined && res !== '' && res !== null) {
      return true
    } else {
      return false
    }
  }
  this.compareDateTime = function (date1, date2) {
    var oDate1 = new Date(date1)
    var oDate2 = new Date(date2)
    if (oDate1.getTime() >= oDate2.getTime()) {
      return true
    } else {
      return false
    }
  }
  this.isNotNull = function (res) {
    if (res !== undefined && res !== '' && res !== null) {
      return true
    } else {
      return false
    }
  }
  this.isNull = function (res) {
    return !this.isNotNull(res)
  }
  this.emptyObj = function (obj) {
    for (let key in obj) {
      return false // 非空
    }
    return true
  }
  this.contains = function (arr, obj) {
    var i = arr.length
    while (i--) {
      if (arr[i] === obj) {
        return true
      }
    }
    return false
  }
  this.num = function (obj) {
    obj.value = obj.value.replace(/[^\d.]/g, '') // 清除"数字"和"."以外的字符
    obj.value = obj.value.replace(/^\./g, '') // 验证第一个字符是数字
    obj.value = obj.value.replace(/\.{2,}/g, '.') // 只保留第一个, 清除多余的
    obj.value = obj.value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
    obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
  }
}

export const validUtil = new ValidUtil()



// WEBPACK FOOTER //
// ./src/utils/valid.js